import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import { Text } from '../Text';

export const Wrapper = styled.div((props) => ({
    position: 'relative',
}));

type ButtonProps = {
    isOpen: boolean;
};

export const Button = styled('button', {
    shouldForwardProp: (prop) => prop !== 'isOpen',
})<ButtonProps>(
    ({ theme }) => ({
        alignItems: 'center',
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        gap: theme.space[1],
        color: theme.colors.black,
        display: 'grid',
        gridTemplateColumns: 'auto minmax(65px, auto) auto',
        minWidth: 148,

        ':focus': {
            outline: 'none',
        },

        svg: {
            height: 18,
            width: 18,
        },
    }),
    ifProp('isOpen', () => ({
        svg: {
            transform: 'rotate(180deg)',
        },
    })),
);

export const ButtonLabel = styled(Text)(({ theme }) => ({
    color: theme.colors.grey90,
}));

export const ButtonValue = styled(Text)(() => ({}));

export const List = styled.ul(({ theme }) => ({
    position: 'absolute',
    right: 0,
    width: 230,
    zIndex: theme.zIndices[2],
    backgroundColor: theme.colors.white,
    boxShadow: theme.shadows.content,

    ':focus': {
        outline: 'none',
    },
}));

type ItemProps = {
    highlighted: boolean;
    isSelected: boolean;
};

export const ListItem = styled.li<ItemProps>(
    ({ theme }) => ({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: `0 ${theme.space[2]}`,
        height: theme.space[7],
        borderBottom: `1px solid ${theme.colors.grey30}`,
    }),
    ifProp({ isSelected: true }, ({ theme }) => ({
        background: theme.colors.brandBlue,

        p: {
            color: theme.colors.white,
        },
    })),
    ifProp({ highlighted: true, isSelected: false }, ({ theme }) => ({
        backgroundColor: theme.colors.grey05,

        p: {
            color: theme.colors.primary,
        },
    })),
);
